import React from 'react';

import classnames from 'classnames';
import { oneOf, string } from 'prop-types';

import './TeaserText.scss';

export const TeaserText = ({ text, className, variant }) => {
  const classes = classnames('teaser', {
    [`${className}`]: !!className,
    [`teaser--${variant}`]: !!variant,
  });

  return <div className={classes}>{text}</div>;
};

TeaserText.propTypes = {
  text: string.isRequired,
  className: string,
  variant: oneOf(['normal', 'no-margin', 'bold']),
};

TeaserText.defaultProps = {
  className: '',
  variant: 'normal',
};
